import axios from "axios";
import config from "../config";
import { toast } from "react-toastify";

const api = axios.create({
  baseURL: config.api.url,
});

api.interceptors.request.use(function (config) {
  const token = localStorage.getItem("authToken");
  config.headers.Authorization = token ? `Bearer ${token}` : "";
  return config;
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error.response?.status;
    const message = error.response?.data?.message;

    if (status === 401) {
      if (message === "Token expired") {
        toast.error("Session has expired. Please login again.");
      } else {
        toast.error("Invalid token. Please login again.");
      }
      localStorage.removeItem("authToken");
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default api;
